import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { SkeletonLoader } from '../../ui';
import { LinearGradient } from '../../ui/components/LinearGradient';
import { defaultScale } from '../../utils/scaling';
import { horizontalScrollConstants } from './HorizontalScroller';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';

interface IProps {
  onPress: () => void;
  text: string;
  loading: boolean;
}

export const SeeAllCard: FunctionComponent<IProps> = ({ onPress, text, loading }) => {
  const loaderStyle = {
    width: horizontalScrollConstants.CARD_WIDTH_WIDE,
    borderRadius: horizontalScrollConstants.CARD_BOARDER_RADIUS,
    height: horizontalScrollConstants.CARD_HEIGHT,
  };

  return (
    <HorizontalScrollerCard
      style={styles.container}
      wideCard={false}
      lastCard={true}
      onPress={onPress}
    >
      {loading &&
        <SkeletonLoader containerStyle={loaderStyle}/>
      }
      {!loading &&
        <>
          <View style={styles.contents}>
            <Text style={styles.mainText}>{text}</Text>
          </View>
          <LinearGradient
            colors={['transparent', Theme.GREY_DARK]}
            style={styles.gradient}
            start={{ x: 1, y: 0 }}
            end={{ x: 0, y: 1 }}
            webClassName={'summary-dashboard-see-all-insights-tile'}
          />
        </>
      }
    </HorizontalScrollerCard>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.GREY_DARK_MEDIUM,
  },
  contents: {
    flexDirection: 'row',
    paddingVertical: defaultScale(25),
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    zIndex: 1,
  },
  mainText: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
    margin: 15,
    zIndex: 2,
  },
  gradient: {
    ...StyleSheet.absoluteFill,
    opacity: 0.8,
  },
});
